<template>
  <Form class="commonForm" :ref="refName" :model="formModel"
    :style="{'overflow-y':'auto','overflow-x':'hidden'}" :rules="formRules"
     label-position="top">
     <Spin size="large" fix v-if="spinShow"></Spin>
    <Row >

      <Col span="24">
        <FormItem 
          :label="_vm.$t('产品型号')" 
          prop="model_code">
            <!-- <Input v-model="formModel.model_code"  placeholder="请输入协议列表名称"   :disabled="hasDetails"/> -->
            <Select v-model="formModel.model_code" transfer  :placeholder="_vm.$t('请选择产品型号')"  disabled="true">
              <Option 
                v-for="item in model_codeData" 
                :value="item.model_code" 
                :key="item.model_code">{{ item.name }} ({{item.model_code}})</Option>
            </Select>
          </FormItem>
      </Col>

      <Col span="24">
        <FormItem 
          :label="_vm.$t('硬件版本号')" 
          prop="hardware_ver">
            <!-- <Input v-model="formModel.model_code"  placeholder="请输入协议列表名称"   :disabled="hasDetails"/> -->
            <Select v-model="formModel.hardware_ver" transfer    :placeholder="_vm.$t('请选择硬件版本号')" disabled="true" >
              <Option 
                v-for="item in hardware_verData" 
                :value="item.hardware_ver" 
                :key="item.hardware_ver">{{ item.hardware_ver }}</Option>
            </Select>
          </FormItem>
      </Col>

      <Col span="24">
        <FormItem 
          :label="_vm.$t('项目号')" 
          prop="project_code">
 
            <Select v-model="formModel.project_code"    transfer  :placeholder="_vm.$t('请选择项目号')" disabled="true">
              <Option 
                v-for="item in project_codeData" 
                :value="item.project_code" 
                :key="item.project_code">{{ item.project_code }}</Option>
            </Select>
          </FormItem>
      </Col>
      <Col span="24">
        <FormItem class="w12" label="">
        <div>{{_vm.$t('原版本')}}</div>
        <div>
          <Row :gutter="5">
            <Col span="12">
              <Row>
                <Col span="10">
                  <Select v-model="start.key" filterable @on-change="checkVerson">
                    <Option v-for="(item,index) in origina_Key" :value="item.value"
                            :key="index">{{item.key}}</Option>
                  </Select>
                </Col>
                <Col span="14">
                  <Select v-model="start.value" filterable @on-change="checkVerson" :placeholder="_vm.$t('开始版本')"
                        >
                    <Option :value="0">{{_vm.$t('无')}}</Option>
                    <Option v-for="(item,index) in origina_version" transfer :value="item.firmware_ver_int"
                            :key="index">{{item.firmware_ver}}</Option>
                  </Select>
                </Col>
              </Row>
            </Col>
            <Col span="12">
              <Row>
                <Col span="10">
                  <Select v-model="end.key" filterable @on-change="checkEndVerson" >
                    <Option v-for="(item,index) in origina_Key1"
                            :value="item.value"
                            :key="index">{{item.key}}</Option>
                  </Select>
                </Col>
                <Col span="14">
                  <Select v-model="end.value" filterable @on-change="checkEndVerson" transfer  :placeholder="_vm.$t('结束版本')"
                          >
                    <Option :value="0">{{_vm.$t('无')}}</Option>
                    <Option v-for="(item,index) in origina_version1"
                            :value="item.firmware_ver_int"
                            :key="index">{{item.firmware_ver}}</Option>
                  </Select>
                </Col>
              </Row>
            </Col>
          </Row>

        </div>
      </FormItem>
      </Col>
 
      <Col span="24">
        <FormItem 
          :label="_vm.$t('目标版本')" 
          prop="firmware_ver">
          <Input v-model="formModel.firmware_ver"  :placeholder="_vm.$t('请输入目标版本')"  disabled="true"/> 
          </FormItem>
      </Col>

      <Col span="24">
       <FormItem prop="starttime" class="w12" :label="_vm.$t('开始升级时间')">
        <DatePicker type="datetime" format="yyyy-MM-dd HH:mm:ss" :placeholder="_vm.$t('请选择开始升级时间')" transfer style="width: 100%"
                    v-model="timeChangeValue" @on-change="timeChange"></DatePicker>
       </FormItem>
      </Col>


      <Col span="24">
        <FormItem 
          :label="_vm.$t('升级范围')" 
          prop="send_scope">
            <Select v-model="formModel.send_scope"   transfer  :placeholder="_vm.$t('请选择升级范围')"   @on-change="sendscopeChange" >
              <Option 
                v-for="item in send_scopeData" 
                :value="item.value" 
                :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
      </Col>

      <Col span="24">
        <FormItem 
          :label="_vm.$t('方式')" 
          prop="import_type" v-if="fs">
 
            <Select v-model="formModel.import_type"   transfer  :placeholder="_vm.$t('请选择方式')" @on-change="importtypeChange">
              <Option 
                v-for="item in typeData" 
                :value="item.value" 
                :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
      </Col>

      <Col span="24">
        <FormItem 
          :label="_vm.$t('输入设备ID')" 
          prop="testids2" v-if="srsbid">
          <Input v-model="formModel.testids2"  type="textarea"  :placeholder="_vm.$t('回车输入多个设备ID')" @on-change="testidsChange"/>
          </FormItem>
      </Col>

      <Col span="24">
        <FormItem 
          :label="_vm.$t('上传设备ID')" 
          prop="file_url"
          v-if="scsbid">
          <div v-model="formModel.file_url"></div>
          <div style="width:100%">
            <Upload
              ref="uploadFile"
              :action= "actionUrl" 
              :headers="headers"
              :name="fileName" 
              :data="extraData"
              :on-remove="clearFirmware"
              :on-success="handleContractSuccess"
              type="drag"
              :before-upload="handleContractBeforeUpload"
              :default-file-list="defaultFileList"
              class="ivu-upload-list"
              >
              <div style="padding: 2px 0">
                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                <p>上传设备ID文件（xls或xlsx文件）</p>
              </div> 
            </Upload>
          </div>
          <a style="margin-top:16px" href="http://pcphp.test.xcthings.com/example/example_dids.xlsx" download="uploads_xls.xlsx">{{_vm.$t('下载示例文件')}}</a>
          </FormItem>
      </Col>  

    </Row>
     
  </Form> 
</template>

<script>
import config from '@/config'
import {pests} from '@/api/api_url'
import {renderFormMixins} from '@/mixins/renderFormMixins'
import {get_type,catch_fear_timelist,deviceinfo_list} from '@/api/jingxiaoshang'
 
import { getToken, formatYMD,deepcopy } from '@/libs/util'
import {jingxiaoshang} from '@/api/api_url' 
export default {
  name: "addAppCustom",
  mixins: [renderFormMixins],
  data () {
    return {
      orgVersosn: [],//原版本的数据源
      origina_version: [],//原版本start
      origina_version1: [],//原版本end
      start: {
          key: '>',
          value: 0
        },
        end: {
          key: '<',
          value: 0,  
        },
        origina_Key: [
          {
            value: '>',
            key: this._vm.$t('大于'),
          },
          {
            value: '>=',
            key: this._vm.$t('大于等于'),
          },
          // {
          //   value:'=',
          //   key:'等于',
          // },

        ],
        origina_Key1: [
          {
            value: '=',
            key:this._vm.$t('等于'),
          },
          {
            value: '<',
            key:this._vm.$t('小于'),
          },
          {
            value: '<=',
            key: this._vm.$t('小于等于'),
          }
        ],
      fs:0,
      srsbid:0,
      scsbid:0,
      send_scopeData: [
        {"value":1,'label':this._vm.$t('指定设备')},
        {"value":3,'label':this._vm.$t('全部设备')}
      ],
      typeData: [
        {"value":1,'label':this._vm.$t('输入设备ID')},
        {"value":2,'label':this._vm.$t('导入设备ID')}
      ],
      timeChangeValue:'',
      tabaleValue:'1',
      hasUpload:true,
      defaultFileList:[],
      headers:{
        Authorization:getToken()
        },
      extraData:{
        //  model_code:'',
       //   hardware_ver: '',
      //    project_code:'',
          firmware_ver:''
        },
      fileName:"filename",
      firmware_typeData: [
        { "firmware_type": 0, "firmware_type_name": "请求升级" },
        { "firmware_type": 1, "firmware_type_name": "强制升级" },
      ],
      tableloading:false,
      modelcodeData:[],//数据
      hardware_verData: [],
      path:[],
      reqBase: {},
     // firmwareData:{},
      formModel: {
         project_code: '',
         hardware_ver:'',
         firmware_code: '',
         firmware_ver: '',
         model_code: '',
         chan_num: 0,
         file_url: '',
         starttime: '',
         send_scope: '',
         import_type: '',
         testids2:''
      },
      spinShow:false,
      formRules: {
       
        model_code:[{required: true, type:'string',message: this._vm.$t('产品型号不能为空'), trigger: 'change'}],
        hardware_ver: [
          {required: true, type:'string',message: this._vm.$t('硬件版本号不能为空'), trigger: 'change'}
        ],
        project_code: [
          {required: true, type:'string',message: this._vm.$t('项目号不能为空'), trigger: 'change'}
        ],
        firmware_ver: [
          {required: true, type:'string',message:this._vm.$t('固件版本号不能为空') , trigger: 'change'}
        ],
        starttime: [{required: true,type:'string',message: this._vm.$t('开始升级时间必须'), trigger: 'change'}],
        
        send_scope: [
          {required: true, type:'number',message: this._vm.$t('升级范围不能为空'), trigger: 'change'}
        ],
        import_type: [
          {required: true, type:'number',message:  this._vm.$t('方式不能为空'), trigger: 'change'}
        ],
        testids2: [
          {required: true, type:'string',message:this._vm.$t('设备ID不能为空') , trigger: 'change'}
        ],
        file_url: [
          {required: true, type:'string',message: this._vm.$t('设备ID文件不能为空') , trigger: 'change'}
        ],
        
      },
      nodeList:[],
      tempData:{},//等待提交的临时数据
    }
  },
  props: {
    _vm: {},
    edit: {
      type:Boolean,
      default:false
    },
    
 hasDetails:{
        type:Boolean,
        default:false
      },
    $store: {},
    setData: {},
    model_codeData: {},
    hardware_verData: {},
    project_codeData: {},
    firmwareData:{},
    parent_code:{},
    parent_name: {},
    //origina_version: {}, 
   // origina_version1: {}, 
    orgVersosn:{}
  },
  components: {
      
  },
  computed: {
    actionUrl(){
      let result = '';
      if (process.env.NODE_ENV === 'development') {
        result = config.baseUrl.dev + "" + jingxiaoshang.upload_dids
      } else if (process.env.VUE_APP_BUILD === 'production') {
        result = config.baseUrl.pro + "" + jingxiaoshang.upload_dids
      } else {
        result = config.baseUrl.alp + "" + jingxiaoshang.upload_dids
      }
 
      return result;
    },
    projectCode(){
      return this.$store.state.user.projectCode
    }
  },
  methods: {
    testidsChange(val) {
   
    },
    //检查目标版本开始  判断当前可选的目标版本和end 的原版本
    checkVerson() {
      debugger
     // console.log("小谢1",this.origina_version);
      //  console.log("小谢1",this.orgVersosn)
        let vm = this;
        //过滤目标版本的可选 及获取结束原版本的可选
        //重置结束原版本与目标版本
      this.origina_version1.splice(0);
      // console.log("小谢2",this.orgVersosn);
      // return;
        //this.aimsVerson.splice(0); 
        if (this.start.value && !this.end.value) {
          let tempVerson = deepcopy(this.orgVersosn);
       //   console.log("小谢",tempVerson)
          for (let i = 0; i < tempVerson.length; i++) {
            let list = tempVerson[i];
            if (this.start.value === list.firmware_ver_int) {
              //供拆分的过滤数组
              let resuetArr;//被删除的数据
              let index = i;
              //判断被符号
              if (this.start.key === '>') {
                
                index = index - 1;
                //最大
                if (i === 0) {
                  tempVerson.splice(0);
                } else if (i > 0) {
                  resuetArr = tempVerson.splice(i);
                }
              } else if (this.start.key === '>=') {

                if (i === 0) {
                  resuetArr = tempVerson.splice(i, 1);
                  tempVerson = resuetArr;
                } else if (i > 0) {
                  if (i === tempVerson.length - 1) {
                    //resuetArr=tempVerson.splice(i);
                  } else {
                    resuetArr = tempVerson.splice(i);
                  }

                }
              }
              //目标版本与结束原版本所获得的结果
              this.origina_version1 = tempVerson;
              //过滤可选的目标版本
             /// this.filerTargeVer(this.start.value);
              break;
            }
          }
        } else {
         
        /// this.filerTargeVer();
         this.origina_version1=deepcopy(this.orgVersosn);
        } 
      },
      //检查目标结束版本 判断目标版本的可选项
      checkEndVerson() {
         
        let vm = this;
        //重置开始原版本与目标版本
        this.origina_version.splice(0);
        //this.aimsVerson.splice(0);
        let tempVerson = deepcopy(this.orgVersosn);
        if (this.end.value) {
          for (let i = 0; i < tempVerson.length; i++) {
            let list = tempVerson[i];
            if (this.end.value === list.firmware_ver_int) {

              //供拆分的过滤数组
              let resuetArr;//被删除的数据
              let index = i;
              let _start=0;
              let _end = tempVerson.length;
              console.log("小谢3",this.end.key)
              //debugger
              //判断被符号
              if (this.end.key === '<') {
               // console.log("xiaoxie5",...tempVerson.slice(i+1,_end))
                this.origina_version.push(...tempVerson.slice(i+1,_end));
                //判断原版本的选中是否有效果
                if(this.origina_version.length>0){
                  if(this.start.value){
                    let _temp=false;
                    for(let jj in this.origina_version){
                      if(this.origina_version[jj].firmware_ver_int===this.start.value){
                        _temp=true;
                        break;
                      }
                    }
                    if(!_temp){
                      this.$set(this.start,'value',0);
                    }
                  }
                }else{
                  this.$set(this.start,'value',0);
                }
              } else if (this.end.key === '<=') {
                this.origina_version.push(...tempVerson.slice(i+1,_end));
                //判断原版本的选中是否有效果
                if(this.origina_version.length>0){
                  if(this.start.value){
                    let _temp=false;
                    for(let jj in this.origina_version){
                      if(this.origina_version[jj].firmware_ver_int===this.start.value){
                        _temp=true;
                        break;
                      }
                    }
                    if(!_temp){
                      this.$set(this.start,'value',0);
                    }
                  }
                }else{
                  this.$set(this.start,'value',0);
                }
              } else if (this.end.key === '=') {
                this.$set(this.start,'value',0);
                this.origina_version=[]
              }
              // //开始目标版本与原版本所获得的结果
              // this.origina_version = tempVerson;
              //过滤可选的目标版本
              //this.filerTargeVer(this.end.value);
              //过滤可选的开始原版本 
              this.filterSourStartVer();
              break;
            }
          }
        } else{
          this.filerTargeVer();
          //alert(1)
          this.origina_version=deepcopy(this.orgVersosn);
        }
      },
      //过滤可选的目标版本
      filerTargeVer(value) {
        return;
      //  this.aimsVerson.splice(0);
        //判断开始与结束的原版本，以获取可选择的目标版本
        if (!this.start.value && !this.end.value) {
          console.log(111)
       //   this.aimsVerson = deepcopy(this.firmwareList);
        } else {
          console.log(222) 
          let firmwareList= deepcopy(this.firmwareList);
          let _start=0,
            _end=firmwareList.length;
          if(this.start.value){
            for(let i=0;i<firmwareList.length;i++){
              let list=firmwareList[i];
              if(list.firmware_ver_int===this.start.value){
                if (this.start.key === '>') {
                  _start=i;
                } else if (this.start.key === '>=') {
                  _start=i+1;
                }
                break;
              }
            }
          }
          if(this.end.value){
            for(let i=0;i<firmwareList.length;i++){
              let list=firmwareList[i];
              if(list.firmware_ver_int===this.end.value){
                //判断被符号
                if (this.end.key === '<') {
                  _end=i+1;
                } else if (this.end.key === '<=') {
                  _end=i;
                } else if (this.end.key === '=') {
                  _start=i;
                  _end=i;
                }
                break;
              }
            }
          }
          if(this.start.value && !this.end.value) {
            let result = firmwareList.slice(0, _start);
          //  this.aimsVerson.push(...result);
          }else{
            let result=firmwareList.slice(0,_end);
          //  this.aimsVerson.push(...result);
          }
        }
        let resultVer = false;
        if (this.formInline.firmware_code) {
          // for (let j = 0; j < this.aimsVerson.length; j++) {
          //   let item = this.aimsVerson[j];
          //   if (item.firmware_code === this.formInline.firmware_code) {
          //     resultVer = true;
          //     break;
          //   }
          // }
          if (!resultVer) {
            //需要重新选择目标版本
            this.$set(this.formInline, "firmware_code", '');
          }
        }
      },

      //过滤开始的原版本
    filterSourStartVer() {
        //alert(123)
        //判断目标版本是否有可选的范围中
        let resultVer = false;
        if (this.start.value) {
          for (let j = 0; j < this.origina_version.length; j++) {
            let item = this.origina_version[j];

            if (item.firmware_ver_int === this.start.value) {
              resultVer = true;
              break;
            }
          }
          if (!resultVer) {
            //需要选择原版本开始版本
            this.$set(this.start, "value", '');
          }
        }
      },
     //时间改变
     timeChange(evt){
        console.log(evt);
        this.formModel.starttime = evt;
      },
    importtypeChange(val) {
      if (val == 1) { //1 输入
        this.srsbid=1
        this.scsbid=0
      } else { //2 导入
        this.srsbid=0 
        this.scsbid=1
     }
    },
    sendscopeChange(val) {
      if (val == 3) { //全部
        this.fs=0
        this.srsbid=0
        this.scsbid=0
      } else { //1指定设备ID
        this.fs=1
        this.srsbid=0 
        this.scsbid=0
      }
     this.formModel.import_type=''
    },
    handleContractSuccess(res, file) {
        let vm=this; 
        this.uploading=false;
        if(res.result===0){
       
          let url = res.body.file_url;
          console.log("url",url)
          this.$set(this.formModel, "file_url", url);
          this.$set(this.formModel,"testids",res.body.testids);
          
        } else {
         // console.log("1000")
          // vm.$Message.error(vm.errorCode[res.result]);
          let msg = res.errorMsg
          this.clearFirmware()
          vm.$Message.error(msg) 
        }
      },
    
    tabChange(name){
        this.$set(this,'tabaleValue',name)
      },
    changeDescZh(html,text){
        if(text===''){
          this.$set(this.formModel,"zh",text)
        }else{
          this.$set(this.formModel,"zh",html)
        }
      },
      changeDescEn(html,text){
        if(text===''){
          this.$set(this.formModel,"en",text)
        }else{
          this.$set(this.formModel,"en",html)
        }
      },
    handleContractBeforeUpload (file) {
        const isLt100M = file.size / 1024 / 1024 <= 120;
        if (!isLt100M) { 
          this.clearFirmware()
          this.$Message.error("固件大小不可超过120M");
          return true
        }

        if(!this.hasUpload){
          this.$refs.uploadFile.clearFiles();
            this.$set(this.formModel, "file_url", null);
        } else {
          console.log("检测中")
          this.checkupload()
          return false
        }
        
      },
    /**
       * 改变后需要重新上传
       */
    clearFirmware() {
      //  alert(123)
        this.defaultFileList.splice(0)
        this.$set(this.formModel,"file_url",'')
    },
     
      
      //检查上传
      checkupload(callback){
        //let fieldValidate=['model_code','firmware_ver','hardware_ver','project_code']
        let fieldValidate=['firmware_ver'] 
        let _self=this;
        Promise.all(fieldValidate.map(item=>{
          let p=new Promise(function(resolve,reject){
            _self.$refs[_self.refName].validateField(item,(error)=>{
              resolve(error)
            })
          })
          return p
        })).then((data) => {
      
          let _data=data.filter(item=>item)
          if(!_data.length){
            _self.hasUpload=false;
            if(callback){
              callback()
            }
          }else{
            _self.hasUpload=true;
          }
        })
      },
    /**
     * 单个删除
     */
    delDevice(row){
      for(let i=0;i<this.data2.length;i++){
        let list=this.data2[i]
        if(row.device_id===list.device_id){
          //同时删除临时对象中的数据
          let index=this.tempData[list.node_code].indexOf(list.device_id)
          if(index>-1){
            this.tempData[list.node_code].splice(index,1)
          }
          this.data2.splice(i,1)
          break;
        }
      }
    },
    clickNode(data){
      this.data1.splice(0)
      this.tableloading=true;
      this.$set(this.reqBase,'page',1)
      this.$set(this.reqBase,'page_size',2000)
      this.$set(this.reqBase,'node_code',data.node_code)
      this.$set(this.reqBase,'project_code',this.projectCode)
      deviceinfo_list(this.reqBase).then(res=>{
        this.tableloading=false;
        if(res.result===0){
          let list=res.body.list || []
          this.data1.push(...list)
        }else{

        }
      })
    },
    addTimeFun(){
      this.$refs.addTime.showModal(true)
    },
    
    createTree(data){
      for(let i in data){
        let list=data[i]
        list['value']=list.cate_code
        list['label']=list.cate_name
        if(list.children && list.children.length>0){
          this.createTree(list.children)
        }
      }
    },
    getTreeNodeData(callback){
      this.spinShow=true;
      this.nodeList.splice(0)
      patrolcateGetAllCate({
        project_code:this._vm.$store.state.user.projectCode
      }).then(res=>{
        this.spinShow=false
        if(res.result===0){
          let data=res.body
          this.createTree(data)
          this.nodeList.push(...data)
          if(callback){
            callback(this.nodeList)
          }
        }else{

        }
        
      })
    },
    
    init () {
      
    },
    /**
     * 获取节点所在数组的位置
     */
    getTreeNodeArray(tree, func, path){
      if (!tree) return []
        for (const data of tree) {
          // 这里按照你的需求来存放最后返回的内容吧
          //这里的date是表示我是根据date去查询父级的，你可以修改成你的需求，其他不变
          path.push(data.node_code) 
          if (func(data)) 
            return path
          if (data.children) {
            const findChildren = this.getTreeNodeArray(data.children, func, path)
            if (findChildren.length) 
              return findChildren
          }
          path.pop()
        }
        return []
    },
    /**
     * 返回数据
     */
    setTimeRule(timeObj){
      this.$set(this.formModel.plan_interval,'plan_start',timeObj.plan_start)
      this.$set(this.formModel.plan_interval,'plan_end',timeObj.plan_end)
      this.$set(this.formModel.plan_interval,'interval',timeObj.interval)
      this.$set(this.formModel,'plan_accuracy',timeObj.plan_accuracy)
    }
  },
  mounted() {
    console.log("aaaaaaaaa",this.firmwareData)
    console.log("orgVersosn",this.orgVersosn)
    console.log("this.setData",this.setData)
    console.log("firmwareData", this.firmwareData)
      
    this.origina_version = deepcopy(this.orgVersosn);
    this.origina_version1 = deepcopy(this.orgVersosn);
   
 
    this.checkupload();
 
   // this.checkupload();

    this.$nextTick(() => {
  
    this.$set(this.formModel, 'model_code', this.firmwareData.model_code);
    this.$set(this.formModel, 'hardware_ver', this.firmwareData.hardware_ver);
    this.$set(this.formModel, 'project_code', this.firmwareData.project_code);
    this.$set(this.formModel, 'firmware_ver', this.firmwareData.firmware_ver);
    this.$set(this.formModel, 'firmware_code', this.firmwareData.firmware_code);
      this.$set(this.extraData, 'firmware_ver', this.firmwareData.firmware_ver);
    
      if (this.edit) {
        Object.assign(this.formModel, this.setData)
        this.checkupload();
        if (this.edit) {
          this.$set(this.formModel, 'import_type', this.setData.import_type);
          if (this.setData.send_scope == 1) {
            this.fs = 1;
            if (this.setData.import_type == 1) {
              this.srsbid = 1;
            } else {
              this.scsbid = 1;
            }
          }
          this.$set(this.formModel, 'starttime', this.setData.starttime);
          this.$set(this, 'timeChangeValue', this.setData.starttime);

          console.log("this.setData", this.setData)
          if (this.setData.origina_version.hasOwnProperty('start')) {
            console.log("111", JSON.stringify(this.start))
            let start = this.setData.origina_version.start;
            this.$set(this.start, 'key', start.key);
            this.$set(this.start, 'value', start.value > 0 ? start.value : 0);
            console.log("111", JSON.stringify(this.start))
          }
          // this.start.key=">="
          if (this.setData.origina_version.hasOwnProperty('end')) {
            let end = this.setData.origina_version.end;
            this.$set(this.end, 'key', end.key);
            this.$set(this.end, 'value', end.value > 0 ? end.value : 0);
            console.log("222", JSON.stringify(this.end))
          }

          

          //  this.checkVerson();
          //   this.checkEndVerson();           

        }
      }
    })
 
  
  },
  created() {
 
    if (this.setData !== undefined) {
        Object.assign(this.formModel, this.setData);
     
        this.$set(this.extraData,'firmware_ver',this.setData.firmware_ver);
        //this.$set(this.extraData,'id',this.setData.id);
   
        if(this.formModel.import_type===2){
          this.defaultFileList.push({
            name:this.setData.file_url,
            url:this.setData.file_url
          })
        }
        
        if(this.setData.change_log){
          let change_log=this.setData.change_log;
          if(change_log.zh){
            this.$set(this.formModel, 'zh', change_log.zh);
          }
          if(change_log.en){
            this.$set(this.formModel, 'en', change_log.en);
          }
        }
        
      }else{
        if(this.model_code){
          this.$set(this.formModel,'model_code',this.model_code);
          this.$set(this.extraData,'model_code',this.model_code);
        }
      }
  }
}
</script>

<style scoped>
  .commonForm /deep/ .ivu-form-item-label {
      text-align: left !important;
  }
  .demo-upload-list {
      display: inline-block;
      width: 60px;
      height: 60px;
      text-align: center;
      line-height: 60px;
      border: 1px solid transparent;
      border-radius: 4px;
      overflow: hidden;
      background: #fff;
      position: relative;
      box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
      margin-right: 4px;
  }

  .demo-upload-list img {
      width: 100%;
      height: 100%;
  }

  .demo-upload-list-cover {
      display: none;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, .6);
  }

  .demo-upload-list:hover .demo-upload-list-cover {
      display: block;
  }

  .demo-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }

  .titleCol {
      text-align: center;
  }

  .uploadTip {
    font-size: 12px;
    margin-top: -10px;
    margin-bottom: 10px;
  }
  .contentImg{
    width: 500px;
  }
  .contentIcon{
    cursor:pointer
  }
  .layout50, .layout100 {
    margin-bottom: 15px;
  }

  .layout50 {
    width: calc(50% - 12px);
    padding-left: 8px;
    padding-right: 8px;
  }
  .classLayout{
    display: flex;
    flex-wrap: wrap;
    margin-left: -8px;
    margin-right: -8px;
  }
   .addLayout{
    text-align: left;
    margin-left:8px;
  }
  .uploadInner{
    position: relative;
  }
  .uploadDelIcon{
    position:absolute;
    top:5px;
    right:5px;
    z-index: 1111;
  }
  .bm-view {
    width: 100%;
    height: 300px;
  }
  .mapWrapper{
    position: relative;
  }
  .mapWrapper .inputContent{
    position: absolute;
    top:5px;
    left:0;
    z-index: 55;
    width:180px;
  }
  .addressLabel{
    display: inline-block;
    width: 100%;
    position: relative;
    vertical-align: middle;
    line-height: normal;
  }
  .noLabel{
    margin-top:30px;
  }
  .ivu-upload-list /deep/   .ivu-upload-list-file-finish{
    word-wrap: break-word; /* 允许在单词内换行 */
  overflow-wrap: break-word; /* 同上，现代浏览器推荐使用这个属性别名 */
  white-space: normal; /* 允许自动换行 */
  }
</style>
